import { render, staticRenderFns } from "./SelectFileToUploadComponent.vue?vue&type=template&id=4a6a706e&data-cy=dataIngestionComponent&"
import script from "./SelectFileToUploadComponent.vue?vue&type=script&lang=ts&"
export * from "./SelectFileToUploadComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a6a706e')) {
      api.createRecord('4a6a706e', component.options)
    } else {
      api.reload('4a6a706e', component.options)
    }
    module.hot.accept("./SelectFileToUploadComponent.vue?vue&type=template&id=4a6a706e&data-cy=dataIngestionComponent&", function () {
      api.rerender('4a6a706e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SelectFileToUploadComponent.vue"
export default component.exports